export default __webpack_public_path__ + "images/check.e9adf79a0d0d1267709f7fc4a58641fd.svg";